import { render, staticRenderFns } from "./AppHeaderNoauth.vue?vue&type=template&id=22bf8ce0&scoped=true&lang=pug&"
var script = {}
import style0 from "./AppHeaderNoauth.vue?vue&type=style&index=0&id=22bf8ce0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf8ce0",
  null
  
)

export default component.exports